// extracted by mini-css-extract-plugin
module.exports = {"outer":"_3xrP8","gradientWrapper":"_2SXWC","heading":"_2D6nv","subHeading":"oP60v"};